import { createAction } from '@ngrx/store';

export const loadCache = createAction('[Cache] Load cache');
